import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { avecMéthodesLivrablesCaractérisés } from './livrable-caracterisé.methods';
import { LivrableCaractérisé } from '../model/livrable-caracterisé.model';

export const LivrableCaractériséStore = signalStore(
  { providedIn: 'root' },
  withEntities<LivrableCaractérisé>(),
  withSelectedEntity(),
  avecMéthodesLivrablesCaractérisés(),
);
